<div class="page-header">
    <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-grow-1">
            <img alt="Logo" src="../../../../../assets/images/logo.png" class="app-logo" />
        </div>
        <app-stepper></app-stepper>
    </div>
</div>
